import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';

export const QrCode = ({hash, type = 'box'}) => (
    <Card sx={{maxWidth: 185, mb: 4, margin: '0 auto'}}>
        <CardMedia
            component="img"
            width="164"
            height="164"
            image={`${process.env.REACT_APP_BASE_URL}/${type}/${hash}/qr`}
            alt="QR"
        />
    </Card>
);
